import { render, staticRenderFns } from "./form-portals.vue?vue&type=template&id=632eba0c&"
import script from "./form-portals.vue?vue&type=script&lang=js&"
export * from "./form-portals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports